<template>
  <div class="personal-detail-2 personal-detail-box-s">
    <el-form :model="formData" label-position="top" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="'* '+ $t('personalDetails2.Postcode')" prop="Postcode">
            <el-input  id="Postcode" :value="formData.Postcode" @blur="inputFields('Postcode')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="'* '+ $t('personalDetails2.Addr')" prop="Addr" v-show="!['GBR','ITA','DEU'].includes(formData.Country)">
              <el-input id="Addr" :value="formData.Addr" @blur="inputFields('Addr')"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="!['GBR','ITA','DEU'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Addr2')" prop="Addr2">
            <el-input  id="Addr2" :value="formData.Addr2"  @blur="inputFields('Addr2')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['GBR','ITA','DEU'].includes(formData.Country)">
          <el-form-item :label="'* '+ $t('personalDetails2.Building_Name')" prop="Building_Name">
            <el-input id="Building" :value="formData.Building_Name"  @blur="inputFields('Building')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['GBR','ITA','DEU'].includes(formData.Country)">
          <el-form-item :label="'* '+ $t('personalDetails2.Street')" prop="Street">
            <el-input  id="Street" :value="formData.Street" @blur="inputFields('Street')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="'* '+ $t('personalDetails2.City')" prop="City">
            <el-input id="City" :value="formData.City"  @blur="inputFields('City')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['ITA'].includes(formData.Country)">
          <el-form-item :label="'* '+ $t('personalDetails2.Province')" prop="Province">
            <el-input id="Province" :value="formData.Province"  @blur="inputFields('Province')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('personalDetails2.Nationality')" prop="Nationality">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Nationality" class="select-width" filterable :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in $t('personalDetails1.countrySelect')" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-row :gutter="20">
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('personalDetails2.birthDate')" prop="Birth_Date_Day">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Birth_Date_Day" class="select-width" filterable :placeholder="$t('personalDetails2.birthSecond')">
                  <el-option v-for="(item,index) in getDays" :key="index" :label="item" :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item label=" " prop="Birth_Date_Month">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Birth_Date_Month" class="select-width" filterable :placeholder="$t('personalDetails2.birthMonth')">
                  <el-option v-for="(item,index) in getMonths" :key="index" :label="item" :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item label=" " prop="Birth_Date_Year">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Birth_Date_Year" class="select-width" filterable :placeholder="$t('personalDetails2.birthYear')">
                    <el-option v-for="(item,index) in getYears" :key="index" :label="item" :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="isShowDocNo">
          <el-form-item :label="getDocNoLabel" prop="Doc_No">
            <el-input v-model="formData.Doc_No"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Bank')" prop="Bank">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Bank" class="select-width" :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in $t('personalDetails2.bankSelect')" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)&&formData.Bank=='other'">
          <el-form-item :label="$t('personalDetails2.OtherBank')" prop="OtherBank">
            <el-input v-model="formData.OtherBank"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Bank_Card_No')" prop="Bank_Card_No">
            <el-input v-model="formData.Bank_Card_No"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Beneficiary_Name')" prop="Beneficiary_Name">
            <el-input v-model="formData.Beneficiary_Name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Branch_Province')" prop="Branch_Province">
            <el-input v-model="formData.Branch_Province"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Branch_City')" prop="Branch_City">
            <el-input v-model="formData.Branch_City"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="['CHN'].includes(formData.Country)">
          <el-form-item :label="$t('personalDetails2.Branch_Name')" prop="Branch_Name">
            <el-input v-model="formData.Branch_Name"></el-input>
          </el-form-item>
        </el-col>
        <UploadItem :formData="formData" ref="uploadEl"></UploadItem>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('personalDetails2.isHaveCitizen')" prop="isHaveCitizen">
            <el-radio-group v-model="formData.isHaveCitizen">
              <div class="radio-h5">
                <el-radio label="Y">{{$t('personalDetails2.CitizenSelect.Y')}}</el-radio>
              </div>
              <div class="radio-h5">
                <el-radio label="N">{{$t('personalDetails2.CitizenSelect.N')}}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('personalDetails2.isDualCitizenship')" prop="isDualCitizenship">
            <el-radio-group v-model="formData.isDualCitizenship">
              <div class="radio-h5">
                <el-radio label="Y">{{$t('personalDetails2.DualCitizenshipSelect.Y')}}</el-radio>
              </div>
              <div class="radio-h5">
                <el-radio label="N">{{$t('personalDetails2.DualCitizenshipSelect.N')}}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.isDualCitizenship == 'Y'">
          <el-form-item :label="$t('personalDetails2.Dual_Nationality')" prop="Dual_Nationality">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Dual_Nationality" class="select-width" filterable :placeholder="$t('messages.unSelect')">
              <el-option v-for="(item,index) in CountrySelect" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--新增 政府公众人物-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :class="LANGUAGE !='ar' ? 'el-col-persional' :'el-col-persional-ar'" >
            <el-form-item :label="$t('personalDetails2.IS_Politically_Person')" prop="IS_Politically_Person">
              <el-radio-group v-model="formData.IS_Politically_Person">
                <div class="radio-h5">
                  <el-radio label="Y">{{$t('personalDetails2.IS_Politically_Person_Select.Y')}}</el-radio>
                </div>
                <div class="radio-h5">
                  <el-radio label="N">{{$t('personalDetails2.IS_Politically_Person_Select.N')}}</el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
            <!--提示-->
            <el-popover
                    placement="right-end"
                    popper-class="popper-show-cla"
                    trigger="hover"
                    v-if="screenWidth>1024">
              <p class="politically-text" v-html="$t('personalDetails2.IS_Politically_Exposed')"></p>
              <i slot="reference" class="el-icon-info icon-politically"></i>
            </el-popover >

            <div class="el-dialog-content" v-else>
              <el-dialog
                      :visible.sync="centerDialogVisible"
                      width="90%"
                      lock-scroll
                      show-close
                      center>
                <div  class="el-dialog-div">
                  <p class="politically-text" v-html="$t('personalDetails2.IS_Politically_Exposed')"></p>
                </div>

              </el-dialog>
              <i  class="el-icon-info icon-politically" @click="centerDialogVisible = true"></i>
            </div>



          </el-col>

      </el-row>
    </el-form>    
  </div>
</template>

<script>
import {mapState} from "vuex";
import UploadItem from "@/components/fileupload";
import verify_bank from '@/assets/js/isTrueBankNo.js'
import isCnNewID from '@/assets/js/isCnNewID.js'
import getIdNamesByCountries from '@/lang/getIdNamesByCountries.js'
import getAge from '@/assets/js/getAge.js'
import {formatBirthDate,getCountries} from '@/assets/js/uitl.js'
import moment from 'moment'



export default {
  name: "personalDetail2",
  mixins: [
    require("@/assets/mixin/base.js").base('personalDetails2')
  ],
  props: ['Lead', 'middle_dataware'],
  data() {
    const bankCard = (rule, value, callback) => {
      if (this.formData.Country == 'CHN') {
        if (!value || value == '') return callback(this.$t('customErrMsg.fieldIsRequired.Bank_Card_No'));
        else if (verify_bank(this.formData.Bank_Card_No)) return callback();
        return callback(this.$t('errors.bankNumError'));
      }
      return callback()
    }
    const docNum = (rule, value, callback) => {
      if (this.formData.Nationality == 'CHN') {
        if (!value || value == '') return callback(this.$t('errors.Doc_No'));
        else if (!isCnNewID(value)) return callback(this.$t('errors.DocTypeNoError'));
        return callback()
      }
      return callback()
      if ((!value || value == '')&& msg.required == true)return callback(this.$t('errors.Doc_No'));
      return callback();
    }
    const allowEndSpace = (rule, value, callback) => {
      if(/^\s.*/ig.test(value)) return lang.customErrMsg.fieldIsRequired[msg.model];
      // else if (((!value) && msg.required)) return lang.customErrMsg.fieldIsRequired[msg.model];
      else if (!value || value == '') return lang.customErrMsg.fieldIsRequired[msg.model];
      else if(msg.type=='select'&&value=='UN'&& msg.required == true) return lang.customErrMsg.fieldIsRequired[msg.model];
      return null;
    }
    const BirthDateYear = (rule, value, callback) => {
      if(!value) callback(new Error(this.$t('messages.unSelect')))
      if(value&&this.formData.Birth_Date_Month&&this.formData.Birth_Date_Day) {
        this.validateFn(value, this.formData.Birth_Date_Month,this.formData.Birth_Date_Day,callback);
      }else callback();
    }
    const BirthDateMonth = (rule, value, callback) => {
      if(!value) callback(new Error(this.$t('messages.unSelect')))
      if(this.formData.Birth_Date_Year&&value&&this.formData.Birth_Date_Day) {
        this.validateFn(this.formData.Birth_Date_Year, value,this.formData.Birth_Date_Day,callback);
      }else callback();
    }
    const BirthDateDay = (rule, value, callback) => {
      if(!value) callback(new Error(this.$t('messages.unSelect')))
      if(this.formData.Birth_Date_Year&&this.formData.Birth_Date_Month&&value) {
        this.validateFn(this.formData.Birth_Date_Year, this.formData.Birth_Date_Month,value,callback);
      }else callback();
    }
    const OtherBank = (rule, value, callback) => {
      if (this.formData.Bank != "other") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.OtherBank")));
      }
      callback()
    }
    const Bank = (rule, value, callback) => {
      if (this.formData.Country != "CHN") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Bank")));
      }
      callback()
    }
    const BeneficiaryName = (rule, value, callback) => {
      if (this.formData.Country != "CHN") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Beneficiary_Name")));
      }
      callback()
    }
    const BranchProvince = (rule, value, callback) => {
      if (this.formData.Country != "CHN") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Branch_Province")));
      }
      callback()
    }
    const BranchCity = (rule, value, callback) => {
      if (this.formData.Country != "CHN") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Branch_City")));
      }
      callback()
    }
    const BranchName = (rule, value, callback) => {
      if (this.formData.Country != "CHN") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Branch_Name")));
      }
      callback()
    }
    const Addr = (rule, value, callback) => {
      if (!this.isCheckedFiled){  return  callback() };
      if (["GBR","ITA","DEU"].includes(this.formData.Country)) callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Addr")));
      }
      callback()
    }
    const BuildingName = (rule, value, callback) => {
      if (!this.isCheckedFiled){  return  callback() };
      if (!["GBR","ITA","DEU"].includes(this.formData.Country)) callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Building_Name")));
      }
      callback()
    }
    const City = (rule, value, callback) => {
      if (!this.isCheckedFiled){  return  callback() };
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.City")));
      }
      callback()
    }
    const Postcode = (rule, value, callback) => {
      if (!this.isCheckedFiled){  return  callback() };

      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Postcode")));
      }
      callback()
    }
     const Street = (rule, value, callback) => {
       if (!this.isCheckedFiled){  return  callback() };
      if (!["GBR","ITA","DEU"].includes(this.formData.Country)) callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Street")));
      }
      callback()
    }
     const Province = (rule, value, callback) => {
       if (!this.isCheckedFiled){  return  callback() };
      if (!["ITA"].includes(this.formData.Country)) callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Province")));
      }
      callback()
    }
     const isHaveCitizen = (rule, value, callback) => {
      if (!value || value == '') return callback(new Error(this.$t("customErrMsg.fieldIsRequired.isHavePass")));
      if (value == "Y") return callback(new Error(this.$t("personalDetails2.citizen_Tip")));
      callback()
    }
     const isDualCitizenship = (rule, value, callback) => {
      if (!value || value == '') {
        return callback(new Error(this.$t("personalDetails2.citizen_Tip")));
      }
      callback()
    }
     const DualNationality = (rule, value, callback) => {
       if(this.formData.isDualCitizenship == 'Y'){
        if (!value || value == '') {
          return callback(new Error(this.$t("personalDetails2.citizen_Tip")));
        }
       }
      callback()
    }
     const ISPoliticallyPerson = (rule, value, callback) => {
       if (!value ) {
         return callback(new Error(this.$t("customErrMsg.fieldIsRequired.IS_Politically_Person")));
       }
       callback()
     }
    return {
      rulesArr:[
        {name: "Addr",type: "input",rules: [{required: false,validator: Addr},{min:1,max: 200}]},
        {name: "Addr2",type: "input",rules: [{required: false},{max: 200}]},
        {name: "Building_Name",type: "input",rules: [{required: false,validator: BuildingName},{max: 200}]},
        {name: "Street",type: "input",rules: [{required: false,validator: Street},{max: 200}]},
        {name: "City",type: "input",rules: [{required: false,validator: City},{max: 20}]},
        {name: "Province",type: "input",rules: [{required: false,validator: Province},{max: 200}]},
        {name: "Postcode",type: "input",rules: [{required: false,validator: Postcode},{max: 12}]},
        {name: "Birth_Date_Year",type: "select",rules: [{required: true,validator:BirthDateYear,customText:true}]},
        {name: "Birth_Date_Month",type: "select",rules: [{required: true,validator:BirthDateMonth,customText:true}]},
        {name: "Birth_Date_Day",type: "select",rules: [{required: true,validator:BirthDateDay,customText:true}]},
        {name: "Nationality",type: "select",rules: [{required: true}]},
        {name: "Doc_No",type: "input",rules: [{required: false},{max: 30}]},
        {name: "Bank",type: "select",rules: [{required: true,validator:Bank}]},
        {name: "OtherBank",type: "input",rules: [{required: true,validator:OtherBank},{max: 50}]},
        {name: "Bank_Card_No",type: "input",rules: [{required: true,validator:bankCard},{max: 30}]},
        {name: "Beneficiary_Name",type: "input",rules: [{required: true,validator:BeneficiaryName},{max: 60}]},
        {name: "Branch_Province",type: "input",rules: [{required: true,validator:BranchProvince},{max: 100}]},
        {name: "Branch_City",type: "input",rules: [{required: true,validator:BranchCity},{max: 100}]},
        {name: "Branch_Name",type: "input",rules: [{required: true,validator:BranchName},{max: 200}]},
        {name: "isHaveCitizen",type: "radio",rules: [{required: true,validator:isHaveCitizen,customText:true}]},
        {name: "isDualCitizenship",type: "radio",rules: [{required: true,validator:isDualCitizenship}]},
        {name: "Dual_Nationality",type: "select",rules: [{required: true, validator: DualNationality}]},
        {name: "IS_Politically_Person",type: "radio",rules: [{required: true,validator: ISPoliticallyPerson}]},
      ],
      isShowDocNo:true,
      current_date: new Date(),
      screenWidth: document.body.clientWidth,
      centerDialogVisible:false,
      isCheckedFiled:false,

    };
  },
  mounted(){
     _g.trackStepPage(2);
    // recodeModel插入 图片字段
    const uploadFiles = Object.keys(this.$refs.uploadEl.imgModel)
    let personalDetails2 = this.$parent.$parent.recodeModel['personalDetails2']
    personalDetails2.push(...uploadFiles);
    personalDetails2 = new Set(personalDetails2)
  },
  watch:{
    'formData.Nationality'(val) {
      if(val in getIdNamesByCountries){
        if(getIdNamesByCountries[val]==='CONCAT') this.isShowDocNo  = false;
        else{ 
          this.$store.commit("SAVEDOCNOLABEL",getIdNamesByCountries[val])
          this.isShowDocNo  = true;
        }
      }else{
        this.$store.commit("SAVEDOCNOLABEL",getIdNamesByCountries['AllOtherCountries'])
        this.isShowDocNo  = true;
      }
    },
    'formData.Birth_Date_Year'(val) {
      this.inputFields('')
      //this.validateField(['Birth_Date_Month','Birth_Date_Day'])
    },
    'formData.Birth_Date_Month'(val) {
      this.inputFields('')
      //this.validateField(['Birth_Date_Year','Birth_Date_Day'])
    },
    'formData.Birth_Date_Day'(val) {
      this.inputFields('')
      //this.validateField(['Birth_Date_Year','Birth_Date_Month'])
    }
  },
  computed:{
    rules(){
      return this.$getRules(this.rulesArr);
    },
    getYears() {  // 获取出生日期-年份select
      let currYear = new Date().getFullYear();
      var yearMax = currYear - 18;
      let obj = {};
      for (var i = yearMax; i > yearMax - 100; i--) {
        obj[i] = i;
      }
      return obj;
    },
    ...mapState(["DocNoLabel","LANGUAGE"]),
    getDocNoLabel(){
      return this.DocNoLabel?this.DocNoLabel:this.$t('personalDetails2.Doc_No');
    },
    getMonths() {  // 获取出生日期-月select
      return this.gen_mons(this.formData.Birth_Date_Year);
    },
    getDays(){
      return this.gen_days(this.formData.Birth_Date_Year, this.formData.Birth_Date_Month);
    },
    CountrySelect(){
      return getCountries(this.$t('personalDetails1.countrySelect'));
    }
  },
  methods: {
    inputFields(value){
      value ? setTimeout(()=>{this.DateValue(value)},500) : this.DateValue(value);
    },
    DateValue(value){
      const arr = ["Addr","Addr2","Street","Building", "City","Province","Postcode"];
      arr.forEach(item=>{
        let val = item == 'Building' ? '_Name' : '';
        this.formData[item+val] = document.getElementById(item).value;
      })
    },
    getDateArr(num) {
      let obj = {};
      for (var i = 1; i <= num; i++) {
        obj[i] = i;
      }
      return obj;
    },
    getPageFormData(cb) {
      this.isCheckedFiled = true; //验证提示错误
      this.$refs["ruleForm"].validate((valid) => {
        if (valid&&this.validateUploaded()) {
          //更新salesforce步骤
          Util.editSalesforce(this.middle_dataware, 2);
          this.selectTitle();
          return cb(true);
        } else {
          this.isCheckedFiled = false; //验证提示错误
            // return cb(true);
          return cb(false);
        }
      });
    },
    validateUploaded() { // 验证图片
      const imgModel = this.$refs.uploadEl.imgModel
      for(let key in imgModel){
        if(imgModel[key].imgIsRequired&&!Boolean(this.formData[key][0])) return false;
      }
      return true;
    },
    selectTitle() {
      let fields = this.$refs["ruleForm"].fields;
      // 处理地址
      if (['GBR','DEU'].includes(this.formData.Country)) Util.resetField(['Addr','Addr2','Province'], fields,this.formData);
      else if (['ITA'].includes(this.formData.Country)) Util.resetField(['Addr','Addr2'], fields,this.formData);
      else Util.resetField(['Building_Name','Street','Province'], fields,this.formData);
      // 处理银行信息
      if (!['CHN'].includes(this.formData.Country)) Util.resetField(['Bank','OtherBank','Bank_Card_No','Beneficiary_Name','Branch_Province','Branch_City','Branch_Name','Bank_Addr','SWIFT_Code'], fields,this.formData);
      // 处理其他银行
      if (['CHN'].includes(this.formData.Country)&&this.formData.Bank != 'other')Util.resetField(["OtherBank"], fields,this.formData);
      // 处理身份证
      if(!this.isShowDocNo) Util.resetField(["Doc_No"], fields,this.formData);
      //处理双重国籍
      if(this.formData.isDualCitizenship == 'N') Util.resetField(['Dual_Nationality'], fields, this.formData)
    },
    validateFn(selectYear,selectMonth,selectDay,callback){
      // if(!selectYear||!selectMonth||!selectDay) return callback(new Error(this.$t("errors.invalidDate")));
      // else if (moment(selectYear + "-" + (selectMonth) + "-" + selectDay, 'YYYY-MM-DD').isValid()) {
      if (moment(selectYear + "-" + (selectMonth) + "-" + selectDay, 'YYYY-MM-DD').isValid()) {
        // const age = getAge(selectYear, selectMonth, selectDay);
        // if (age < 18) return callback(new Error(this.$t("errors.invalidBirthDate")));
        this.formData.Birth_Date = formatBirthDate(selectYear,selectMonth,selectDay);
        return callback();
      }
      else callback(new Error(this.$t("errors.invalidDate")));
    },
    validateField(fields){
      fields.forEach(item=>{
        this.$refs["ruleForm"].validateField(item);
      })
    },
    // 出生日期处理
    gen_days(year, mon) {
      // 获取出生日期-日select
      // 以当前时间为标准
      // 新复制一份时间
      let _current = new Date(this.current_date);
      // 如果当前存在已经选择的year和month，更新复制的时间
      if (year) {_current.setFullYear(parseInt(year));}
      if (mon) {_current.setMonth(parseInt(mon)-1);}
      // 如果mon存在
      if (this.formData.Birth_Date_Month) {
        // 如果year存在
        if (this.formData.Birth_Date_Year) {
          // 先处理下月和日的关系
          this.deal_mon_day(_current);
          // 如果当前年份-所选年份大于18，表明，该年龄大于18岁
           if (this.current_date.getFullYear() - _current.getFullYear() > 18) {
             return this.getDateArr(this.gen_year_everyMonth_days(_current.getFullYear(), _current.getMonth()+1));
           } else {
             // 如果当前年份-所选年份等于18，表明，用户可能为18岁
             // 需要再次判断月和日的关系，并更新月和日数据
             // 月的数据更新，需要在另外的函数gen_mons()中进行
             // 日的数据更新，在这个函数中进行
             if (_current.getMonth() < this.current_date.getMonth()) {
               return this.getDateArr(this.gen_year_everyMonth_days(_current.getFullYear(), _current.getMonth()+1));
             } else {
               if (parseInt(this.formData.Birth_Date_Day) > this.current_date.getDate()) {
                 this.formData.Birth_Date_Day = "";
               }
               return this.getDateArr(this.current_date.getDate());
             }
           }
        } else {
          // 如果当前选择的day的值大于该月份的最大day的值，清空选择，更新day数据，让用户再次选择
          // 如果当前选择的day的值小于该月份的最大day的值，保留选择，更新day数据
          this.deal_mon_day(_current);
          return this.getDateArr(this.gen_year_everyMonth_days(_current.getFullYear(), _current.getMonth()+1));
        }
      } else {
        // 返回当前day的数据
        return this.getDateArr(this.gen_year_everyMonth_days(_current.getFullYear(), _current.getMonth()+1));
      }
    },
    gen_mons(year) {
      let _current = new Date(this.current_date);
      if (year) {_current.setFullYear(parseInt(year));}
      if (_current.getFullYear() == this.current_date.getFullYear()-18) {
        return this.getDateArr(this.current_date.getMonth()+1);
      } else {
        return this.getDateArr(12);
      }
    },
    // 日期计算相关函数
    // 闰年判断
    is_leap(year){
      return (year%100==0?(year%400==0?true:false):(year%4==0?true:false));
    },
    // 获取某年某个月的天数
    gen_year_everyMonth_days(year, mon){
      return mon == 2 ? this.is_leap(year) ? 29 : 28 : [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][mon-1];
    },
    // 处理月和日关系
    deal_mon_day(current){
      if (this.gen_year_everyMonth_days(current.getFullYear(), current.getMonth()+1) < parseInt(this.formData.Birth_Date_Day)) {
        this.formData.Birth_Date_Day = "";
      }
    }
  },
  components: {
    UploadItem
  }
};
</script>

<style lang="scss">
.el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
  line-height: normal; 
}
.personal-detail-2 {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  .form-tip {
    font-size: 11px;
    color: #939597;
    padding: 10px 0;
  }
  .time-icon-color {
    color: #f2672a;
    margin-right: 10px;
  }
  .select-width {
    width: 100%;
  }
  @media (max-width: 415px){
    .el-form-item__label{
      font-size: 12px;
    }
  }
  .el-form-item__label{
    color: black;
    // white-space:nowrap;
  }

  .icon-politically{
    padding-top: 5px;
    padding-left: 5px;
  }

  .icon-politically{
    padding-top: 5px;
    padding-left: 5px;
  }


  .el-col-persional{
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .el-col-persional-ar{
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: flex-start;
  }

  .el-dialog-div{
    height: 520px;
    overflow: auto;
  }

  .el-dialog--center .el-dialog__body {
    padding: 0px 14px 0px 14px !important;

  }
}
.personal-detail-box-s{
  margin-top: 10px !important;
}

.politically-text{
    color: black;
    padding: 10px;
    max-width: 900px;
    line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/steps/personal-detail-2.vue